import { render, staticRenderFns } from "./packageIndex.vue?vue&type=template&id=10dac7d9&scoped=true&"
import script from "./packageIndex.vue?vue&type=script&lang=js&"
export * from "./packageIndex.vue?vue&type=script&lang=js&"
import style0 from "./packageIndex.vue?vue&type=style&index=0&id=10dac7d9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dac7d9",
  null
  
)

export default component.exports